import CreateSurvey from './CreateSurveyContainer';

export default CreateSurvey;
